import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import { combineReducers } from "redux";

export const currentPartnerFileReducer = (state = initialState.partnerFiles.currentFile, action) => {
  switch (action.type) {
    case actionTypes.CREATE_PARTNER_FILE_STARTED: {
      return {
        ...state,
        saving: true,
        saved: false
      };
    }

    case actionTypes.CREATE_PARTNER_FILE_FAILED: {
      return {
        ...state,
        saving: false,
        saved: false,
        failed: true
      };
    }

    case actionTypes.CREATE_PARTNER_FILE_SUCCEEDED: {
      const { documentId, siteId, partnerId } = action.payload;
      return {
        ...state,
        saving: false,
        saved: true,
        documentId,
        siteId,
        partnerId
      };
    }

    case actionTypes.CREATE_PARTNER_FILE_REDIRECTED: {
      return { saving: false };
    }

    default:
      return state;
  }
}

export const partnerFileItemReducer = (state = initialState.partnerFiles.item, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_FILE_HEADER_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        item: Object.assign([], { loading: true })
      };

      return result;
    }

    case actionTypes.LOAD_PARTNER_FILE_HEADER_SUCCESS: {
      let result = { ...state };
      result[action.key] = {
        ...action.payload,
        loading: false,
        loaded: true
      };

      return result;
    }

    case actionTypes.LOAD_PARTNER_FILE_HEADER_FAILED: {
      let result = { ...state };
      result[action.key] = {
        loading: false,
        loaded: false
      };

      return result;
    }

    case actionTypes.PARTNER_FILE_HEADER_INVALIDATED: {
      let result = { ...state };
      delete result[action.event.eventBody.documentId];
      return result;
    }

    case eventTypes.PARTNER_FILE_STATE_UPDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          ...state[key],
          documentStateId: action.event.eventBody.stateId,
          documentStateName: action.event.eventBody.stateName
        }
      };
    }

    default:
      return state;
  }
};

export const partnerFileNextStatesReducer = (state = initialState.partnerFiles.partnerFileNextStates, action) => {
  switch (action.type) {
    case actionTypes.COMPUTE_PARTNER_FILE_NEXT_STATES_STARTED: {
      let result = { ...state };
      result[action.key] = Object.assign({}, { loading: true, loaded: false });
      return result;
    }

    case eventTypes.PARTNER_FILE_NEXT_STATES_LIST_COMPUTED: {
      let result = { ...state };
      result[`${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`] = Object.assign(
        [],
        action.event.eventBody.nextStates,
        { loading: false, loaded: true }
      );
      return result;
    }

    case eventTypes.PARTNER_FILE_NEXT_STATES_LIST_INVALIDATED: {
      let result = { ...state };
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      delete result[key];
      return result;
    }

    default:
      return state;
  }
};

export const partnerFileUserPreferencesReducer = (state = initialState.partnerFiles.userPreferences, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_FILE_USER_PREFERENCES_SUCCESS:
    case actionTypes.UPDATE_PARTNER_FILE_USER_PREFERENCES_SUCCESS:
      return Object.assign([], action.payload, { isLoaded: true });
    default:
      return state;
  }
};

export const partnerFileSelectedUserPreferenceReducer = (
  state = initialState.partnerFiles.selectedUserPreference,
  action
) => {
  switch (action.type) {
    case actionTypes.LOAD_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS:
      return { ...state, ...Object.assign({}, action.payload, { isLoaded: true }) };
    case actionTypes.UPDATE_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS:
      return { ...state, ...Object.assign({}, action.payload, { isLoaded: true }) };
    default:
      return state;
  }
};

export const partnerFileDefaultUserPreferenceReducer = (
  state = initialState.partnerFiles.defaultUserPreference,
  action
) => {
  if (action.type === actionTypes.LOAD_PARTNER_FILE_DEFAULT_USER_PREFERENCE_SUCCESS)
    return { ...state, ...Object.assign({}, action.payload, { isLoaded: true }) };
  return state;
};

const combinedReducer = combineReducers({
  currentFile: currentPartnerFileReducer,
  item: partnerFileItemReducer,
  partnerFileNextStates: partnerFileNextStatesReducer,
  userPreferences: partnerFileUserPreferencesReducer,
  selectedUserPreference: partnerFileSelectedUserPreferenceReducer,
  defaultUserPreference: partnerFileDefaultUserPreferenceReducer
});

const exp = (state, action) => combinedReducer(state, action);
export default exp;
